import { useEffect, useState } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    quote: "The integration with Tally and the dealer management app have been game-changers for us. Optimiz has made our order and payment processes seamless, and our dealers love the easy access to our product catalog.",
    name: 'Alpesh Limbani',
    position: 'CEO, Alpine Seeds',
  },
  {
    quote: "Optimiz has transformed the way we manage our operations. The real-time employee tracking and automated TA/DA reports have saved us countless hours, allowing us to focus on growing our business.",
    name: 'P R Zaveri',
    position: 'Secretary of Gujarat Seeds Association',
  },
  {
    quote: "With Optimiz’s customizable solutions, we’ve been able to streamline our entire business process. The dynamic hierarchy setup and performance tracking features are exactly what we needed to keep our team on track.",
    name: 'Harshit Shah',
    position: 'CEO, Kaps3',
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-heading">
          <h1>What our customers are saying</h1>
          <p>
            Real stories from real people who have transformed their business with Optimiz.
          </p>
        </div>

        <div className="slider-container">
          <div
            className="slider-wrapper"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {testimonialsData.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <p className="quote">"{testimonial.quote}"</p>
                <div className="author-info">
                  <span className="name">{testimonial.name}</span>
                  <span className="position">{testimonial.position}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
